import styled from 'styled-components';

import colors from '@wecasa/common/src/utils/colors';

import Switch from '@wecasa/web-ui/src/components/switch/switch';
import { minWidth } from '@wecasa/web-ui/src/styles/mixins';

export const MEMBERSHIP_CARD_VERTICAL_PADDING = 15;
export const MEMBERSHIP_CARD_MAX_HEIGHT = 100;

export const MembershipCardContainer = styled.div`
  max-height: ${MEMBERSHIP_CARD_MAX_HEIGHT}px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${MEMBERSHIP_CARD_VERTICAL_PADDING}px 20px;
  background-color: ${colors.pink20};
  border-radius: 12px;

  ${minWidth.md`
      margin-bottom: 0;
  `}
`;

export const MembershipCardSwitch = styled(Switch)`
  margin-left: 10px;
`;
